import * as React from 'react';
import {TimelineSeparator, TimelineConnector, TimelineContent, 
  TimelineDot, Timeline, TimelineItem, timelineItemClasses} from '@mui/lab';
import CornellLogo from './ins.png'
import Tyson from './Tyson_Foods.png'
import {Typography, Avatar} from '@mui/material';

export default function LeadershipTimeLine() {
  return (
    <Timeline
      sx={{
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0,
        },
      }}
    >      <TimelineItem>
    <TimelineSeparator>
      <TimelineDot />
      <TimelineConnector />
    </TimelineSeparator>
    <Avatar alt="Cornell University Logo" src={CornellLogo} style={{marginLeft: 20,height: 50,
                         width: 70,borderRadius: '0'}} /> 
    <TimelineContent>
        <Typography sx={{fontWeight: 'bold', fontSize: 18  }}>Product Manager, Instagram</Typography>
        <Typography style={{color: 'Grey'}}>Spring 2023</Typography>
        <Typography sx={{fontWeight: 'bold'}} style={{color: 'Grey', }}>Cornell University Project Digital Technology Immersion</Typography>
        <Typography>
• Led the development and launch of Tunes, a new music platform on Instagram.
</Typography>
<Typography>
• Conducted market research and SWOT analysis to identify opportunities and challenges in the music industry.
</Typography>
<Typography>
• Designed and executed the product vision, including the integration of data analytics, concert shop, and competition platform.
</Typography>
<Typography>
• Collaborated with cross-functional teams to ensure seamless integration with Spotify and Apple Music.
</Typography>
<Typography>
• Developed and executed a go-to-market strategy, including partnerships with influencers and businesses, to increase exposure and revenue for musicians on the platform.
</Typography>
<Typography>
• Managed project teams and provided leadership to ensure successful execution of the project.
</Typography>
<Typography>
• Conducted feasibility studies to answer key questions and validate the business model.
</Typography>
<Typography>
• Developed and tested clear, testable hypotheses for customer engagement and monetization.
</Typography>
<Typography>
• Monitored and analyzed performance metrics to continuously improve the product and user experience.
</Typography>
<Typography>
• Assessed and addressed regulatory challenges related to data privacy and intellectual property.
</Typography></TimelineContent>
  </TimelineItem>
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot />
        </TimelineSeparator>
        <Avatar alt="Logo" src={Tyson} style={{marginLeft: 20,height: 30,
                             width: 70, borderRadius: '0'}} /> 
        <TimelineContent>
        <Typography sx={{fontWeight: 'bold'}}>Application Developer</Typography> 
           <Typography style={{color: 'Grey'}}>2020 - 2022 | 2 Years | Full-Time</Typography>
           <Typography style={{color: 'Grey'}}>AR, Springdale</Typography>
           <Typography>• Delivered executive-level international IT forums and served as a communication liaison</Typography>
           <Typography>• Acted as a communication bridge between Asian and US IT teams</Typography>
           <Typography>• Helped resolve disagreements between Tyson Asian and corporate IT teams</Typography>
           <Typography>• Passionate about building cross-functional relationships</Typography>
           <Typography>• Committed to fostering strong cross-functional partnerships, with a focus on bridging the gap between business and IT teams</Typography>
        </TimelineContent>
      </TimelineItem>
    </Timeline>
  );
}
